import React from "react";
import { View } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { AppText } from "@/components/AppText";
import { FontFamilies } from "@/constants/Typography";
import { EligibleWithdrawal } from "@/types/adminPayout";

type Props = {
  withdrawal: EligibleWithdrawal;
};

const WithdrawalCard: React.FC<Props> = ({ withdrawal }) => {
  return (
    <View style={styles.withdrawalCard}>
      <View style={styles.withdrawalInfo}>
        <AppText style={styles.userId}>User ID: {withdrawal.userId}</AppText>
        <AppText style={styles.amount}>
          ${(withdrawal.amount / 100).toFixed(2)}
        </AppText>
      </View>
      <View style={styles.paymentInfo}>
        <AppText style={styles.paymentProvider}>
          {withdrawal.paymentMethod.provider}
        </AppText>
        <AppText style={styles.paymentEmail}>
          {withdrawal.paymentMethod.email}
        </AppText>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  withdrawalCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: "#EBEBEB",
  },
  withdrawalInfo: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
  },
  userId: {
    fontSize: 16,
    fontFamily: FontFamilies.Inter.SemiBold,
    color: "#161D14",
  },
  amount: {
    fontSize: 18,
    fontFamily: FontFamilies.Inter.Bold,
    color: "#0F9129",
  },
  paymentInfo: {
    gap: 4,
  },
  paymentProvider: {
    fontSize: 14,
    fontFamily: FontFamilies.Inter.SemiBold,
    color: "#161D14",
  },
  paymentEmail: {
    fontSize: 13,
    fontFamily: FontFamilies.Inter.Regular,
    color: "rgba(22, 29, 20, 0.7)",
  },
});

export default WithdrawalCard;
